import React from 'react';
import { instanceOf, func, shape, bool } from 'prop-types';

import DefinationFolderView from './DefinationFolderView';
import { _getStudyTargetGroupedData } from '../../../../../util/deUtils';
import SelectionView from './SelectionView';
import useWindowSize from '../../../shared/useWindowSize';

const DefinationView = ({
  studyDefinition,
  setActiveStudyTarget,
  setSelectedDefinition,
  isLatestStudy,
}) => {
  let groupedData = {
    personal: [],
    shared: [],
    global: [],
  };
  if (studyDefinition.studyTargets.data.length > 0) {
    groupedData = _getStudyTargetGroupedData(studyDefinition.studyTargets.data);
  }

  const size = useWindowSize('importDeMain');
  const totalHeight = size.height;
  const totalFolders = 3;
  const folderHeight = 22;
  const threshold = 28 + 12;
  const defaultHeight = 72;
  let personalHeight = defaultHeight;
  let sharedHeight = defaultHeight;
  let gloablHeight = defaultHeight;

  if (totalHeight) {
    const maxHeight = totalHeight / totalFolders;
    const maxFoldersToShow = Math.floor((maxHeight - threshold) / folderHeight);
    const { personal, shared } = groupedData;
    if (personal.length > maxFoldersToShow) {
      personalHeight = maxHeight;
    } else {
      personalHeight =
        personal.length > 0
          ? personal.length * folderHeight + threshold
          : defaultHeight;
    }
    if (shared.length > maxFoldersToShow) {
      sharedHeight = maxHeight;
    } else {
      sharedHeight =
        shared.length > 0
          ? shared.length * folderHeight + threshold
          : defaultHeight;
    }

    const totalFoldersHeight = totalHeight - (personalHeight + sharedHeight);
    gloablHeight = totalFoldersHeight - 12;
  }

  return (
    <div className="de--def__folder--root">
      <div className="de--row de--flex-col-1" id="importDeMain">
        <div className="de--col de--def__folder--col">
          <DefinationFolderView
            title="Personal"
            folders={groupedData.personal}
            setActiveStudyTarget={setActiveStudyTarget}
            maxHeight={personalHeight}
          />
          <DefinationFolderView
            title="Shared"
            folders={groupedData.shared}
            setActiveStudyTarget={setActiveStudyTarget}
            maxHeight={sharedHeight}
          />
          <DefinationFolderView
            title="Global"
            folders={groupedData.global}
            setActiveStudyTarget={setActiveStudyTarget}
            maxHeight={gloablHeight}
          />
        </div>
        <div className="de--col de--def__folder--selection-col" style={{ maxHeight: totalHeight }}>
          <SelectionView
            studyDefinition={{
              available: studyDefinition.available,
              studyTargets: studyDefinition.studyTargets.data,
            }}
            setSelectedDefinition={setSelectedDefinition}
            isLatestStudy={isLatestStudy}
          />
        </div>
      </div>
    </div>
  );
};

DefinationView.propTypes = {
  studyDefinition: shape({
    activeStudy: instanceOf(Object),
    studyTargets: {
      loading: bool,
      error: bool,
      data: instanceOf(Array),
    },
    available: instanceOf(Object),
    selected: instanceOf(Array),
    imports: instanceOf(Array),
  }),
  setActiveStudyTarget: func,
  setSelectedDefinition: func,
  isLatestStudy: bool,
};

DefinationView.defaultProps = {
  studyDefinition: {
    activeStudy: null,
    studyTargets: {
      loading: true,
      error: false,
      data: [],
    },
    available: null,
    selected: [],
    imports: [],
  },
};

export default DefinationView;
